import { useState } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../lib/utils";

import { Icon } from "@majourneys/icons";
interface CopyButtonProps {
  value: string;
  label: string;
  className?: string;
}

export function CopyButton({ value, label, className }: CopyButtonProps) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  async function handleClick() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // swallow
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={label}
      className={cn(
        "inline-flex items-center gap-2 rounded-full border border-[rgba(4,0,51,0.08)] px-4 py-2 font-sans text-[13px] font-medium text-[#110E39] transition-colors hover:border-[#110E39] hover:text-[#110E39]",
        className,
      )}
    >
      <Icon name={copied ? "ri-check-line text-[#16a34a]" : "ri-file-copy-line"} />
      <span>{copied ? t("activity.copied") : label}</span>
    </button>
  );
}
